// Trigger a browser download.
//
// The pattern: get a Blob, mint a temporary object URL, attach an invisible
// <a download> to the document, click it, then revoke the URL.

export function triggerBlobDownload(filename: string, blob: Blob): void {
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}

// Convenience wrapper for the common "build CSV string in the browser, save"
// case used by the per-widget Download Data buttons.
export function triggerCsvDownload(filename: string, csv: string): void {
  triggerBlobDownload(filename, new Blob([csv], { type: 'text/csv;charset=utf-8' }));
}
